import { cva } from "class-variance-authority";

export const badgeVariants = cva(
  "inline-flex items-center px-[10px] py-[2px] w-fit border-none rounded-[6px] font-normal text-sm",
  {
    variants: {
      variant: {
        default: "bg-gray-100 text-gray-950",
        black: "bg-gray-900 text-zinc-50",
        destructive: "bg-red-600 text-[#B42318] text-zinc-50",
        outline: "text-gray-950 outline outline-zinc-200 bg-white",
        success: "bg-[#E5F1D4] text-[#65A30D]",
        warning: "bg-red-100 text-red-600",
        info: "bg-[#FEF3C7] text-[#D97706]",
        inactive: "bg-gray-100 text-gray-600",
        blue: "bg-[#C8D1F6] text-gray-700",
      },
      size: {
        xs: "text-xs py-[2px]",
        sm: "text-xs py-[3px]",
        md: "text-sm",
      },
      disabled: {
        true: "opacity-50 pointer-events-none",
        false: "",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "md",
      disabled: false,
    },
  }
);
